interface ISubsidaryLevel {
  SG: string;
  JP: string;
  MU: string;
  LT: string;
  MY: string;
  HK: string;
  EU: string;
  CN: string;
}
export type subsidaryType = "SG" | "JP" | "MU" | "LT" | "MY" | "HK" | "EU" | "CN";
export const subsidaryLevel: ISubsidaryLevel = {
  SG: "Singapore",
  JP: "Japan",
  MU: "Mauritius",
  LT: "Lithuania",
  MY: "Malaysia",
  HK:"Hong Kong",
  EU:"Europe",
  CN: "China"
};
export const subsidaryID = [
  {
    label: "PG Singapore",
    value: "SG",
  },
  {
    label: "PG Japan",
    value: "JP",
  },
  {
    label: "PG Mauritius",
    value: "MU",
  },
  {
    label: "PG Lithuania",
    value: "LT",
  },
  {
    label: "PG Malaysia",
    value: "MY",
  },
  {
    label: "PG Hong Kong",
    value: "HK",
  },
  {
    label: "PG Europe",
    value: "EU",
  },
  {
    label: "PG China",
    value: "CN",
  },
];
